/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AnnotationLayer } from 'components/annotationLayer'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { WuhanAnnotationComponent } from 'components/wuhanAnnotationComponent'
import { Summary } from 'components/summary'

import deskHeader from 'images/worldmap_desktop.svg'
import mobHeader from 'images/worldmap_mobile.svg'
// TODO Set the correct article ID here
const isMobile = browserCheck.isMobile
const device = isMobile ? 'mobile' : 'desktop'
const minValForTable = 100
const maxCountForTable = 16

export function AppComponent() {
  const [annotationData, setAnnotationData] = useState()
  const [countryList, setCountryList] = useState()
  const [summed, setSummed] = useState()
  const countries = require('./countries.csv')

  useEffect(() => {
    fetch('https://interaktiv.tagesanzeiger.ch/2020/covid-19-weltkarte/currentData.json')
      .then(response => {
        return response.json()
      })
      .then(data => {
        setAnnotationData(data)
        console.log(data)
        const countryL = []
        const others = []
        const sum = {
          cases: 0,
          death: 0,
          countries: 0,
          updated: new Date()
        }
        data.forEach((c, i) => {
          sum.cases += +c.cases
          sum.death += +c.death
          sum.countries += 1

          if (+c[device].listonly === 1) {
            if (
              c.cases > minValForTable ||
              countryL.length <= maxCountForTable - 2
            ) {
              countryL.push(c)
            } else {
              others.push(c)
            }
          }
        })
        const otherEl = {
          country: 'Others',
          de: 'Reste du monde',
          fr: 'Reste du monde',
          de_mobile: 'Reste du monde',
          cases: 0,
          death: 0
        }
        others.forEach(o => {
          otherEl.cases += o.cases
          otherEl.death += o.death
        })
        countryL.push(otherEl)
        setCountryList(countryL)
        setSummed(sum)
      })
  }, [])

  return (
    <div className='index'>
      <ThemeSwitch />
      <div className='ui vertical very fitted segment'>
        {annotationData && (
          <div className='annotations'>
            <AnnotationLayer
              imageSrc={browserCheck.isMobile ? mobHeader : deskHeader}
              annotations={annotationData}
              AnnotationComponent={WuhanAnnotationComponent}
              id='wuhan_map'
              customLinePadding={browserCheck.isMobile ? 2 : 2}
              customLineHeight={browserCheck.isMobile ? 13 : 10}
              marker={['none', 'none']}
              debug={location.origin.includes('localhost')}
            />
            {countryList && (
              <div className='ui text container '>
                <div className='tableTitle'> Autres pays </div>
                <table className='countryList'>
                  <tbody>
                    {countryList.map((c, i) => {
                      const country = countries.find(ct => ct.iso2c === c.code)
                      let countryName = c.de
                      if (country !== undefined) {
                        // console.log(country)
                        countryName = country.fr
                      }

                      if (i < countryList.length / 2) {
                        const e2 = countryList[i - 1]
                        return (
                          <tr className='entry' key={i}>
                            <td className='text'>{countryName}</td>
                            <td className='cases'>
                              <div>{c.cases}</div>
                            </td>
                            <td className='death'>
                              <div>{c.death}</div>
                            </td>
                          </tr>
                        )
                      }
                      return null
                    })}
                  </tbody>
                </table>
                <table className='countryList'>
                  <tbody>
                    {countryList.map((c, i) => {
                      // console.log(c)
                      const country = countries.find(ct => ct.iso2c === c.code)
                      let countryName = c.de
                      if (country !== undefined) {
                        // console.log(country)
                        countryName = country.fr
                      }

                      if (i >= countryList.length / 2) {
                        const e2 = countryList[i - 1]
                        return (
                          <tr className='entry' key={i}>
                            <td className='text'>{countryName}</td>
                            <td className='cases'>
                              <div>{c.cases}</div>
                            </td>
                            <td className='death'>
                              <div>{c.death}</div>
                            </td>
                          </tr>
                        )
                      }
                      return null
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {summed !== undefined && (
              <Summary
                cases={summed.cases}
                death={summed.death}
                countries={summed.countries}
                updated={summed.updated}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
